export default {
  NOT_SCHEDULED: 'Not Scheduled',
  SCHEDULED: 'Scheduled',
  COMPLETED: 'Completed',
  NO_SHOW: 'No Show',
  RESCHEDULED: 'Rescheduled',
};
